import React, { useMemo } from 'react';
import FilterDropdown from './Filter/components/FilterDropdown';
import { translate } from '../services/translate';

type AlgorithmDropdown = 'hasFacial' | 'hasLpr' | 'hasAreaInvasion';

type Props = {
    required?: boolean;
    zIndex: number;
    disabled?: boolean;
    value: AlgorithmDropdown | 'all';
    setValue: React.Dispatch<React.SetStateAction<AlgorithmDropdown | 'all'>>;
    excludeAreaInvasion?: boolean;
};

function AlgorithmDropdown({ value, setValue, zIndex, required, disabled, excludeAreaInvasion }: Props) {
    const items = useMemo(() => {
        const algorithms: AlgorithmDropdown[] = ['hasFacial', 'hasLpr', 'hasAreaInvasion'];
        return algorithms
            .filter(algorithm => !(excludeAreaInvasion && algorithm === 'hasAreaInvasion'))
            .map(algorithm => ({ label: translate(algorithm), value: algorithm }));
    }, [excludeAreaInvasion]);

    return (
        <FilterDropdown
            label={translate('algorithms')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            required={required}
            disabled={disabled}
        />
    );
}

export default AlgorithmDropdown;
